/* eslint-disable */

import * as PIXI from 'pixi.js-legacy';
import { install } from '@pixi/unsafe-eval';
import spine from 'pixi-spine';
import particles from 'pixi-particles';

install({ ShaderSystem: PIXI.ShaderSystem });

import screenfull from 'screenfull'; 
global.screenfull = screenfull;

import * as TWEEN from '@tweenjs/tween.js';
global.TWEEN = TWEEN;

import jquery from 'jquery';
global.$ = jquery;

import underscore from 'underscore';
global._ = underscore;

import * as P3 from 'p3';

import Main from './Main';

import { WEBGL } from '../libs/WebGL';
import common from './common';

if ('serviceWorker' in navigator && location.hostname !== 'localhost') {
	navigator.serviceWorker.register('service-worker.js');
}

window.addEventListener('beforeinstallprompt', (e) => {
	e.preventDefault();
	window.deferredPrompt = e;
});

const getErrorMessage = () => {
	const message = 'Your device does not support WebGL, which is required for this game to run. Please try another device.';

	const element = document.createElement('div');

	element.id = 'webglmessage';
	element.style.fontFamily = 'monospace';
	element.style.fontSize = '13px';
	element.style.fontWeight = 'normal';
	element.style.textAlign = 'center';
	element.style.background = '#fff';
	element.style.color = '#000';
	element.style.padding = '1.5em';
	element.style.width = '400px';
	element.style.margin = '5em auto 0';

	element.innerHTML = message;

	return element;
};

if (WEBGL.isWebGLAvailable()) {
	const zoom = P3.View.zoom;

	common.STAGE_WIDTH = 2080 * zoom;
	common.STAGE_HEIGHT = 960 * zoom;
	
	const main = new Main(1280 * zoom, 960 * zoom);

	main.init();
} else {
	console.error('No Webgl support');
	window.onload = () => {
		document.body.appendChild(getErrorMessage(1));
	};
}
